import React, { useEffect, useState } from 'react'
import './Homepage.css'
import { auth } from '../firebase'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import Header from './Header'
import { motion } from "framer-motion";
import Footer from './Footer'
import { login } from './utility'
// import Header from '../Components/Header'

function Homepage() {
    const [user, setUser] = useState([])


    useEffect(() => {


        return onAuthStateChanged(auth, user => {
            if (user) {
                console.log(user)
                setUser(user)
            } else {
                console.log(user)

                setUser(null)
            }
        })
    }, [])

    const loginUser = () => login(user)

    const logout = () => {
        // setImgClick(false)
        return signOut(auth)
    }


    return (
        <div className="homepage">
            <Header login={loginUser} logout={logout} user={user} />
            <main className="main_section">
                <div className="main_text" >
                    <span>SHARE LINK ONCE </span>
                    <motion.span initial={{ scale: 0.8 }} animate={{ scale: 1 }} transition={{ duration: 0.5 }}>FOR YOUR YOUTUBE VIDEOS</motion.span>
                </div>


                <img src="Images/yotube-transparent-logo-1.png" alt="youtube" className="yt" />
            </main>
            <section className="home_section">
                <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{
                    duration: 0.8,
                    delay: 0.2
                }}>
                    <p>
                        {/* Get 1 Link for all of your Youtube videos
                        to share on social profiles and never need to change <br />
                        after every new video */}
                        Create a single link for all of your Youtube videos so you can share it on social media without ever having to modify it.
                    </p>
                    <motion.button className="get_started btn-color-2" onClick={loginUser} initial={{ translateX: -100 }} whileInView={{ translateX: 0 }} >
                        Get Started
                    </motion.button>
                </motion.div>
                <motion.div className='phone_images' initial={{ opacity: 0, translateY: 100 }} whileInView={{ opacity: 1, translateY: 0 }} transition={{
                    duration: 0.8,
                    delay: 0.2
                }}>
                    {/* make javascript inner width breakpoints and according to that change the right valye of twitter for animation */}
                    <motion.img initial={{ position: 'default' }} whileInView={{ position: 'absolute' }} src="Images/insta-profile-600.png" alt="insta phone" className="insta" />
                    <motion.img initial={{ rotate: -14 }} whileInView={{ right: '-10vw', rotate: 0 }} transition={{ duration: 0.5, delay: 0.6 }} src="Images/twitter-2.png" alt="twitter phone" className="twitter" />

                </motion.div>
            </section>
            <section>
                <iframe title="steps" src="https://scribehow.com/embed/TubeLink_Link_Generation_Steps__Ol3WMrCUR0yrNGC2ayLG7A" width="100%" height="640" allowfullscreen frameborder="0"></iframe>
            </section>

            <Footer user={user} login={loginUser} logout={logout} />
        </div >
    )
}

export default Homepage